import React, { createContext, useContext, useState } from "react"

const LockContext = createContext()

export const useLock = () => useContext(LockContext)

export const LockProvider = ({ children }) => {
  const [isLocked, setIsLocked] = useState(
    () => localStorage.getItem("isLocked") === "true",
  )

  const lockScreen = () => {
    localStorage.setItem("redirectAfterLogin", window.location.pathname)
    localStorage.setItem("isLocked", "true")
    setIsLocked(true)
  }

  const unlockScreen = () => {
    setIsLocked(false)
    localStorage.removeItem("isLocked")
  }

  return (
    <LockContext.Provider value={{ isLocked, lockScreen, unlockScreen }}>
      {children}
    </LockContext.Provider>
  )
}
